import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useActionItem, useActionItemAction} from 'helpers/hooks/action';
import {wrapChartComponent} from 'helpers/wrapper';
import {Area} from 'recharts';
import utils from 'helpers/utils';
import StyledActionArea from 'components/molecules/Charts/ActionArea/ActionArea.styles';

const AreaChartDot = (props) => {
  const { cx, cy, r,
    width, height,
    stroke, fill, strokeWidth, dataKey,
    payload, index, value,
    hoverDot, hovered,
    onMouseMove, onClick } = props;

  const [active, setActive] = useState(false);
  const clickable = Boolean(onClick);

  const handleMouseEnter = (e) => {
    onMouseMove?.(payload, index, e);
    setActive(true);
  }

  const handleMouseLeave = () => {
    setActive(false);
  }

  const handleMouseMove = (e) => {
    onMouseMove?.(payload, index, e);
  }

  const handleClick = (e) => {
    onClick?.(e, payload, dataKey);
  }

  if (utils.isDefined(value) && (!hoverDot || hovered)) {
    return <circle r={r}
                   x={cx - 10}
                   y={cy - 10}
                   cx={cx}
                   cy={cy}
                   className={`AreaChartDot recharts-dot recharts-area-dot ${clickable ? 'AreaChartDot-clickable' : ''}`}
                   stroke={stroke}
                   strokeWidth={strokeWidth}
                   fill={active ? stroke : fill}
                   width={width}
                   height={height}
                   onClick={handleClick}
                   onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave}
                   onMouseMove={handleMouseMove}/>
  }
};

const ActionArea = React.forwardRef((props, ref) => {
  const {
    action,
    dataKey,
    hovered,
    hoverDot,
    onClick,
    onMouseMove,
    AreaChartDotProps,
    ...innerProps
  } = useComponentProps({
    dot: null,
    activeDot: false,
    ...props
  }, 'ActionArea', {
    static: ['clickable']
  });

  const itm = useActionItem(action);
  const handleActionClick = useActionItemAction(itm?.onClick, onClick);
  const clickable = Boolean(handleActionClick);

  const renderDot = () => {
    return <AreaChartDot r={2}
                         hovered={hovered}
                         hoverDot={hoverDot}
                         onClick={clickable ? (e, payload) => {
                           handleActionClick?.(e, payload, dataKey);
                         } : null}
                         onMouseMove={onMouseMove}
                         {...AreaChartDotProps}/>;
  }

  if (innerProps.dot === true) {
    innerProps.dot = renderDot();
    innerProps.activeDot = false;
  }

  innerProps.className = utils.flattenClassName(innerProps.className, {
    clickable: false
  });

  return <StyledActionArea ref={ref}
                           {...innerProps}
                           dataKey={dataKey}
                           onMouseMove={onMouseMove} />
});

ActionArea.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  action: PropTypes.object,
  hoverDot: PropTypes.bool,
  hovered: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseMove: PropTypes.func,
  AreaChartDotProps: PropTypes.object
};

export default wrapChartComponent(ActionArea, Area);
